import React, { useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { Grid } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import handleRenderOption from "./handleRenderOption";
import { useDispatch, useSelector } from "react-redux";
import { obtenerCatalogoCiudadesAction } from "../../../ducks/catalogoCiudadDuck";
import AltaCiudad from "./AltaCiudad";

const InitialValueCiudad = {
  IdCiudad: 0,
  Nombre: "",
  Codigo: "",
};

const AutoInputCuidades = (props) => {
  const {
    name = "",
    CodigoPais = "0",
    label = "",
    target = InitialValueCiudad,
    setTarget = () => {},
    error = false,
    helperText = "",
  } = props;
  const dispatch = useDispatch();
  const catalogoCiudades = useSelector((store) => store.catalogoCiudad.array);

  useEffect(() => {
    dispatch(obtenerCatalogoCiudadesAction(CodigoPais));
  }, [dispatch, CodigoPais]);

  const getOptionHangle = (event, valor) => {
    if (valor) {
      setTarget(valor);
    } else {
      setTarget(InitialValueCiudad);
    }
  };

  return (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      <Grid item xs={10}>
        <Autocomplete
          id={`id-auto-${name}`}
          value={target}
          options={catalogoCiudades.sort((a, b) => a.Nombre > b.Nombre)}
          getOptionLabel={(option) => `${option.Nombre.trim()}`}
          style={{
            width: "97%",
            margin: "5px",
            paddingBottom: "0",
            fontWeight: "500",
          }}
          disabled={catalogoCiudades.length > 0 ? false : true}
          onChange={getOptionHangle}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              variant="outlined"
              style={{ width: "100%" }}
              name={name}
              error={error}
              helperText={helperText}
            />
          )}
          renderOption={handleRenderOption}
        />
      </Grid>
      <Grid item xs={2}>
        <AltaCiudad CodigoPais={CodigoPais} />
      </Grid>
    </Grid>
  );
};
export default AutoInputCuidades;
